// @stenalpro/gcs — a pure 2D geometric constraint solver plus an optional
// high-level authoring model. Zero dependencies, zero DOM/THREE; runs unchanged
// in an Electron main or renderer process, plain Node, or the browser.
//
//   import { solveSketch, buildSketch } from '@stenalpro/gcs';
//
//   // Native form — solve directly:
//   solveSketch({
//     points: [{ id: 'a', x: 0, y: 0, fixed: true }, { id: 'b', x: 100, y: 0 },
//              { id: 'c', x: 50, y: 90 }],
//     constraints: [{ id: 'k', type: 'angleBetween', points: ['b', 'c', 'a'], value: 90 }],
//   });
//
//   // Authoring form — build from a polygon + high-level constraints, then solve:
//   const { sketch, edges } = buildSketch({
//     pts: [{ x: 0, y: 0 }, { x: 200, y: 0 }, { x: 200, y: 150 }, { x: 0, y: 150 }],
//     edgeCons: [{ o: 'h' }, { o: 'v', len: 150 }, {}, {}],
//     relations: [{ type: 'angleV', vert: 1, value: -90 }],
//   });
//   solveSketch(sketch, { angleEdges: edges });

export { solveSketch, analyzeSketch, wouldConflict } from './solver.js';
export { buildSketch, cornerAngle, REL_META, SOLVER_CONSTRAINTS } from './model.js';
